import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Tim Kalinowski, Founder, and CEO of LORE</h4>
                            <div className="podcast_txt">
                                <p>Helping your business/product transform into a brand through communication, Tekrevol partners with Tim Kalinowski, Founder, and CEO of LORE....</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep4"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Mr. Tyrone Johnson</h4>
                            <div className="podcast_txt">
                                <p>Engineering is one of the brightest educational fields that have a real-world physical impact on the lives of people...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep3"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Mr. Hani Masgidi, Founder of Info Media Consultancy</h4>
                            <div className="podcast_txt">
                                <p>Discussing the topic “From necessity to global standards, how digital technology is reshaping businesses in the MENA region”...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep2"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;